import React, { useContext, useState, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DataContext from './DataContext';
import TextBlock from './blocks/TextBlock';
import DropdownBlock from './blocks/DropdownBlock'
import NumberBlock from './blocks/NumberBlock';
import axios from 'axios';
import { config } from '../../utils/config'
import ImageUpload from './ImageUpload';
import { useParams } from 'react-router-dom';
import { convertDate } from './../../utils/dateConversion'

export default function EditProperty() {

    let { lid } = useParams()
    const navigate = useNavigate()

    const formData = useContext(DataContext)
    const [page1, setPage1] = useState(true);
    const [page2, setPage2] = useState(false);
    const [page3, setPage3] = useState(false);
    const [page4, setPage4] = useState(false);

    const [pid, setPid] = useState("")
    const [block, setBlock] = useState("")
    const [streetName, setStreetName] = useState("")
    const [building, setBuilding] = useState("")
    const [postalCode, setPostalCode] = useState("")
    const [propertyType, setPropertyType] = useState("")
    const [propertySubType, setPropertySubType] = useState("")
    const [tenure, setTenure] = useState("")
    const [wef, setWef] = useState("")
    const [top, setTop] = useState("")
    const [unit, setUnit] = useState("")
    const [room, setRoom] = useState("")
    const [bath, setBath] = useState("")
    const [listingType, setListingType] = useState("")
    const [listingSubType, setListingSubType] = useState("")
    const [term, setTerm] = useState("")
    const [sizeBuilt, setSizeBuilt] = useState("")
    const [sizeLand, setSizeLand] = useState("")
    const [price, setPrice] = useState("")
    const [priceState, setPriceState] = useState("")
    const [gst, setGst] = useState("")
    const [maint, setMaint] = useState("")
    const [headline, setHeadline] = useState("")
    const [description, setDescription] = useState("")
    const [media, setMedia] = useState([])

    const toPage2 = useCallback(() => {
        setPage1(false)
        setPage2(true)
        setPage3(false)
    }, [])

    const toPage1 = useCallback(() => {
        setPage1(true)
        setPage2(false)
        setPage3(false)
    }, [])

    const toPage3 = useCallback(() => {
        setPage1(false)
        setPage2(false)
        setPage3(true)

    }, [])

    const toPage4 = useCallback(() => {
        setPage1(false)
        setPage2(false)
        setPage3(false)
        setPage4(true)
    }, [])

    const updateProperty = useCallback(async () => {

        // withCredentials is to send session/cookie info to server
        const result = await axios.put(`${config.apiBaseUrl}/editlisting/${lid}`, {
            pid, block, streetName, building, postalCode, propertyType, propertySubType, tenure, wef, top, unit, room, bath, listingType,
            listingSubType, term, sizeBuilt, sizeLand, price, priceState, gst, maint, headline, description, media
        }, { withCredentials: true })

        if (result.data === "updated") {
            toPage4()
        } else {
            console.log("error")
        }

    }, [lid, pid, block, streetName, building, postalCode, propertyType, propertySubType, tenure, wef, top, unit, room, bath, listingType,
        listingSubType, term, sizeBuilt, sizeLand, price, priceState, gst, maint, headline, description, media, toPage4])

    useEffect(() => {

        const getData = async () => {

            const response = await axios.get(`${config.apiBaseUrl}/editlisting/${lid}`)
            const d = response.data
            setPid(d.propertyDetails.id)
            setBlock(d.propertyDetails.block)
            setStreetName(d.propertyDetails.street_name)
            setBuilding(d.propertyDetails.project_name)
            setPostalCode(d.propertyDetails.postal_code)
            setPropertyType(d.propertyDetails.property_type)
            setPropertySubType(d.propertyDetails.property_sub_type)
            setTenure(d.propertyDetails.tenure)
            setWef(convertDate(d.propertyDetails.wef))
            setTop(convertDate(d.propertyDetails.top))
            setUnit(d.unit)
            setRoom(d.room)
            setBath(d.bath)
            setListingType(d.listing_type)
            setListingSubType(d.listing_sub_type)
            setTerm(d.listing_condition)
            setSizeBuilt(d.size_built)
            setSizeLand(d.size_land)
            setPrice(d.price)
            setPriceState(d.price_state)
            setGst(d.gst)
            setMaint(d.maint_fee)
            setHeadline(d.headline)
            setDescription(d.description)
        }

        getData()

        const mediaData = formData.getMediaData()
        setMedia(mediaData)

    }, [formData, lid])

    useEffect(() => {

        const mediaData = formData.getMediaData()
        setMedia(mediaData)

    }, [formData])

    return (
        <>
            <div className="container-fluid p-1" style={{ width: "90%" }}>

                <div className="container" style={{ display: page1 ? 'block' : 'none' }}>

                    <div className="progress mb-3" style={{ height: "20px" }}>
                        <div className="progress-bar bg-danger" role="progressbar" aria-label="Segment one" style={{ width: "25%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">Building Details</div>
                    </div>

                    <TextBlock label="Block" value={block} updateParentValue={(value) => { setBlock(value) }} disabled />
                    <TextBlock label="Street Name" value={streetName} updateParentValue={(value) => { setStreetName(value) }} disabled />
                    <TextBlock label="Building/Estate Name" value={building} updateParentValue={(value) => { setBuilding(value) }} />
                    <TextBlock label="Postal Code" value={postalCode} updateParentValue={(value) => { setPostalCode(value) }} disabled />

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle3 })}
                        option={formData.getDropdownData().map((d) => d.formBlockArray3)}
                        updateParentValue={(value) => setPropertyType(value)}
                        value={propertyType} />


                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle4 })}
                        option={
                            formData.getDropdownData().map((d) => { return (d[propertyType]) })
                        }
                        updateParentValue={(value) => setPropertySubType(value)}
                        value={propertySubType} />

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle11 })}
                        option={formData.getDropdownData().map((d) => { return (d.formBlockArray4) })}
                        updateParentValue={(value) => setTenure(value)}
                        value={tenure} />

                    <TextBlock type={"date"} label={formData.getFormLabel().map((d) => { return d.formBlockTitle12 })}
                        updateParentValue={(value) => setWef(value)}
                        value={wef} />

                    <TextBlock type={"date"} label={formData.getFormLabel().map((d) => { return d.formBlockTitle13 })}
                        updateParentValue={(value) => setTop(value)}
                        value={top} />

                    <div>
                        <button className="btn btn-danger" onClick={toPage2}>Next</button>
                    </div>
                </div>

                <div className="container" style={{ display: page2 ? 'block' : 'none' }}>

                    <div className="progress mb-3" style={{ height: "20px" }}>
                        <div className="progress-bar bg-danger" role="progressbar" aria-label="Segment one" style={{ width: "25%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">Building Details</div>
                        <div className="progress-bar bg-danger" role="progressbar" aria-label="Segment two" style={{ width: "25%" }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">Property Details</div>
                    </div>

                    <TextBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle14 })} value={unit ? unit : ""}
                        updateParentValue={(value) => setUnit(value)} />

                    {["Condo", "HDB", "Landed"].includes(propertyType) ? (
                        <DropdownBlock label={formData.getFormLabel().map((d) => d.formBlockTitle19)}
                            option={formData.getDropdownData().map((d) => { return (d.formBlockArray8) })}
                            updateParentValue={(value) => { setRoom(value) }} value={room} />) : null
                    }

                    {["Condo", "HDB", "Landed"].includes(propertyType) ? (
                        <DropdownBlock label={formData.getFormLabel().map((d) => d.formBlockTitle20)}
                            option={formData.getDropdownData().map((d) => { return (d.formBlockArray9) })}
                            updateParentValue={(value) => { setBath(value) }} value={bath} />) : null
                    }

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle1 })}
                        option={formData.getDropdownData().map((d) => { return (d.formBlockArray1) })}
                        updateParentValue={(value) => { setListingType(value) }} value={listingType} />

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle10 })}
                        option={formData.getDropdownData().map((d) => { return (d.formBlockArray2) })}
                        updateParentValue={(value) => { setListingSubType(value) }} value={listingSubType} />

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle15 })}
                        option={formData.getDropdownData().map((d) => { return (d.formBlockArray5) })}
                        updateParentValue={(value) => { setTerm(value) }} value={term} />


                    <NumberBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle6 })}
                        updateParentValue={(value) => { setSizeBuilt(value) }} suffix={" sqft"} value={sizeBuilt} />


                    {["Landed", "Retail", "Industrial", "Land"].includes(propertyType) ? (
                        <NumberBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle7 })}
                            updateParentValue={(value) => { setSizeLand(value) }} suffix={" sqft"} value={sizeLand} />) : null
                    }

                    <NumberBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle8 })}
                        updateParentValue={(value) => { setPrice(value) }} prefix={"$"} value={price} />

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle16 })}
                        option={formData.getDropdownData().map((d) => { return (d.formBlockArray6) })}
                        updateParentValue={(value) => { setPriceState(value) }} value={priceState} />

                    <div className="d-flex justify-content-between">
                        <button className="btn btn-danger" onClick={toPage1}>Back</button>
                        <button className="btn btn-danger" onClick={toPage3}>Next</button>
                    </div>

                </div>

                {/* Break */}

                <div className="container" style={{ display: page3 ? 'block' : 'none' }}>

                    <div className="progress mb-3" style={{ height: "20px" }}>
                        <div className="progress-bar bg-danger" role="progressbar" aria-label="Segment one" style={{ width: "25%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">Building Details</div>
                        <div className="progress-bar bg-danger" role="progressbar" aria-label="Segment two" style={{ width: "25%" }} aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">Property Details</div>
                        <div className="progress-bar bg-danger" role="progressbar" aria-label="Segment two" style={{ width: "25%" }} aria-valuenow="750" aria-valuemin="0" aria-valuemax="100">More Details</div>
                    </div>

                    <DropdownBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle17 })}
                        option={formData.getDropdownData().map((d) => { return (d.formBlockArray7) })}
                        updateParentValue={(value) => { setGst(value) }} value={gst} />

                    <NumberBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle18 })}
                        updateParentValue={(value) => { setMaint(value) }} prefix={"$"} suffix={" /quarter"} value={maint} />

                    <TextBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle9 })}
                        updateParentValue={(value) => { setHeadline(value) }} value={headline} />

                    <TextBlock label={formData.getFormLabel().map((d) => { return d.formBlockTitle5 })}
                        updateParentValue={(value) => { setDescription(value) }} value={description} />

                    <div>
                        <ImageUpload />
                    </div>


                    <div className="d-flex justify-content-between">
                        <button className="btn btn-danger" onClick={toPage2}>Back</button>
                        <button className="btn btn-danger" onClick={updateProperty}>Update</button>
                    </div>
                </div>

                <div className="container" style={{ display: page4 ? 'block' : 'none' }}>
                    <div className="progress mb-3" style={{ height: "20px" }}>
                        <div className="progress-bar bg-danger" role="progressbar" aria-label="Segment four" style={{ width: "100%" }} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">Updated Successfully!</div>
                    </div>

                    <div className="container">
                        <h5>Updated Successfully!</h5>
                    </div>
                    <div>
                        <button className="btn btn-danger" onClick={() => navigate("/agent/dashboard")}>To Dashboard</button>
                    </div>
                </div>

            </div>
        </>
    )

}


